import { createSelector } from 'reselect'
import { filter, values } from 'ramda'

import type { ComplexApiType } from '../MenuComplexesApi'

const selectComplexes: (
  state: { complexes: Record<string, ComplexApiType> },
  props: { getAvailableOnly?: boolean },
) => Array<ComplexApiType> = createSelector(
  ({ complexes }) => complexes,
  ({ getAvailableOnly }: any) => getAvailableOnly || false,
  (complexes: Record<string, ComplexApiType>, getAvailableOnly) =>
    getAvailableOnly ? filter(({ available }) => available, values(complexes)) : values(complexes),
)

export default selectComplexes
